import Repository from './Repository';

const resource = "/scheduler";

export default {
    // Get all scheduled jobs
    list(params = {}) {
        return Repository.get(`${resource}/jobs/`, { params });
    },

    // Get single job
    get(id) {
        return Repository.get(`${resource}/jobs/${id}/`);
    },

    // Create new scheduled job
    create(data) {
        return Repository.post(`${resource}/jobs/`, data);
    },

    // Update scheduled job
    update(id, data) {
        return Repository.patch(`${resource}/jobs/${id}/`, data);
    },

    // Delete scheduled job
    delete(id) {
        return Repository.delete(`${resource}/jobs/${id}/`);
    },

    // Toggle enabled/disabled
    toggle(id) {
        return Repository.post(`${resource}/jobs/${id}/toggle/`);
    },

    // Run job immediately
    run(id, data = {}) {
        return Repository.post(`${resource}/jobs/${id}/run/`, data);
    },

    // Run operation immediately without creating schedule
    runNow(params) {
        return Repository.post(`${resource}/run-now/`, null, { params });
    },

    // Refresh all schedules (restart celery-beat)
    refresh() {
        return Repository.post(`${resource}/refresh/`);
    },

    // Get current schedules from API
    getSchedules() {
        return Repository.get(`${resource}/schedules/`);
    },

    // Get unified scheduler run history
    history(params = {}) {
        return Repository.get(`${resource}/history/`, { params });
    },

    // Clear scheduler run history
    clearHistory() {
        return Repository.delete(`${resource}/history/`);
    }
}
